import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const INotebookExecutionService = ( createDecorator('INotebookExecutionService'));
export { INotebookExecutionService };
